import { userService } from '../../helpers/authservice/user.service';
import router from '../../router/index';

const user = JSON.parse(localStorage.getItem('user'));

export const state = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        return !!state.user;
    },
    currentUser(state) {
        return state.user;
    },
};

export const actions = {
    // Logs in the current user against the real Laravel backend.
    logIn({ commit, dispatch }, { email, password } = {}) {
        commit('loginRequest');

        return userService.login(email, password).then(
            (user) => {
                commit('loginSuccess', user);
                router.push('/');
                return user;
            },
            (error) => {
                commit('loginFailure');
                dispatch('notification/error', error, { root: true });
                return Promise.reject(error);
            }
        );
    },

    // Logs out the current user.
    logOut({ commit }) {
        userService.logout();
        commit('logout');
    },

    // Registers a new user.
    register({ commit, dispatch }, user) {
        commit('registerRequest');

        return userService.register(user).then(
            (result) => {
                commit('registerSuccess');
                dispatch('notification/success', 'Registration successful', { root: true });
                router.push('/login');
                return result;
            },
            (error) => {
                commit('registerFailure');
                dispatch('notification/error', error, { root: true });
                return Promise.reject(error);
            }
        );
    },

    // No password-reset endpoint on the backend yet.
    // eslint-disable-next-line no-unused-vars
    resetPassword({ dispatch }, { email } = {}) {
        const error = 'Password reset is not available yet.';
        dispatch('notification/error', error, { root: true });
        return Promise.reject(error);
    },
};

export const mutations = {
    loginRequest(state) {
        state.status = { loggingIn: true };
        state.user = null;
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    registerRequest(state) {
        state.status = { registering: true };
    },
    registerSuccess(state) {
        state.status = {};
    },
    registerFailure(state) {
        state.status = {};
    },
};
